<header class="header">
  <div class="header-content" [class.header-content--compact]="compact">
    <!-- Botón volver (en páginas de detalle) -->
    <button class="back-button" (click)="goBack()" *ngIf="showBackButton">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M19 12H5M12 19l-7-7 7-7"/>
      </svg>
      Volver
    </button>

    <!-- Logo and title -->
    <div class="header-left" (click)="goHome()" *ngIf="title === 'BarBook' && !showBackButton">
      <img src="/assets/imagotipo.png" alt="BarBook Logo" class="header-logo" [class.header-logo--compact]="compact" />
    </div>

    <!-- Title only (on inner pages) -->
    <div class="header-left" *ngIf="title !== 'BarBook' && !showBackButton">
      <h1 class="header-title-inner">{{ title }}</h1>
    </div>
  </div>
</header>
